import Button from "./button"


export default function ComponentsOverrides(theme) {
    return Object.assign(
        Button()
    )
}